import './style/global.less';
import '@arco-design/web-react/dist/css/arco.css';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { ConfigProvider } from '@arco-design/web-react';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import axios from 'axios';
import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import checkLogin from './utils/checkLogin';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import './mock';
import { profile } from './request/api';

const store = createStore(rootReducer);

function Index() {
  const [lang, setLang] = useStorage('arco-lang', 'zh-CN');
  const [theme, setTheme] = useStorage('arco-theme', 'light');
  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      default:
        return zhCN;
    }
  }

  function fetchUserInfo() {
    // 先获取token
    const token = localStorage.getItem('token');
    if (token == '') {
      localStorage.removeItem('token');
      store.dispatch({
        type: 'update-userInfo',
        payload: { userInfo: {} },
      });
      return;
    }
    console.warn('获取用户信息');
    store.dispatch({
      type: 'update-userInfo',
      payload: { userLoading: true },
    });
    profile({}).then((res) => {
      store.dispatch({
        type: 'update-userInfo',
        payload: { userInfo: res.data.detail, userLoading: false },
      });
    });
  }

  const fetchLocalStorageToState = () => {
    const token = localStorage.getItem('token');
    store.dispatch({
      type: 'update-token',
      payload: { token: token },
    });
    const inviteExpertIds = localStorage.getItem('inviteExpertIds');
    if (inviteExpertIds) {
      store.dispatch({
        type: 'update-inviteIds',
        payload: {
          inviteExpertIds: JSON.parse(inviteExpertIds),
        },
      });
    }
  };

  useEffect(() => {
    fetchLocalStorageToState();
    if (checkLogin()) {
      fetchUserInfo();
    }
  }, []);
  useEffect(() => {
    changeTheme(theme);
  }, [theme]);

  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme,
  };

  return (
    <BrowserRouter>
      <ConfigProvider
        locale={getArcoLocale()}
        componentConfig={{
          Card: {
            bordered: false,
          },
          List: {
            bordered: false,
          },
          Table: {
            border: false,
          },
        }}
      >
        <Provider store={store}>
          <GlobalContext.Provider value={contextValue}>
            <Switch>
              <Route path="/" component={PageLayout} />
            </Switch>
          </GlobalContext.Provider>
        </Provider>
      </ConfigProvider>
    </BrowserRouter>
  );
}

ReactDOM.render(<Index />, document.getElementById('root'));
